export default {"src":"/_next/static/media/microsoft.705df8fc.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};